import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d48c7d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "left"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left-tit" }, "基金类型：", -1))
const _hoisted_3 = {
  key: 0,
  class: "left"
}
const _hoisted_4 = { class: "left-tit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseCircleFilled = _resolveComponent("CloseCircleFilled")!
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!

  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(_ctx.theme)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultIdx, (name, idx) => {
      return (_openBlock(), _createElementBlock("li", { key: idx }, [
        (name === 'FundType')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.result.FundType && _ctx.result.FundType.length)
                ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _hoisted_2,
                    _createTextVNode(_toDisplayString(_ctx.fundTypeValueToLable(_ctx.result.FundType, name)), 1)
                  ])), [
                    [_directive_widthoverflowtitle, _ctx.fundTypeValueToLable(_ctx.result.FundType, name)]
                  ])
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.result[name])
                ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.result[name]?.label) + "：", 1),
                    _createTextVNode(_toDisplayString(_ctx.valToLabel(_ctx.result[name], name)), 1)
                  ])), [
                    [_directive_widthoverflowtitle, _ctx.valToLabel(_ctx.result[name], name)]
                  ])
                : _createCommentVNode("", true)
            ], 64)),
        (_ctx.showDelete && name!=='FundType')
          ? (_openBlock(), _createBlock(_component_CloseCircleFilled, {
              key: 2,
              onClick: ($event: any) => (_ctx.clearCondition(name))
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 2))
}